import * as React from 'react';

export const RadioSymbol = () => (
  <svg viewBox="0 0 21 21" height="21" width="21" className="radio-symbol">
    <g id="radio-circle" transform="translate(.5 0)">
      <circle id="radio-dot" fill="#0067C5" cx="10" cy="10" r="5.7"/>
      <circle cx="10" cy="10" r="8.9" stroke="#0067C5" strokeWidth="2" fill="transparent"/>
    </g>
  </svg>
);
